import React from 'react'
import { RichTextSection } from '@/components/RichTextSection'
import RichText from '@/components/RichText'

export type RichTextSectionBlockProps = {
  heading?: string | null
  content: any
  variant?: 'card' | 'plain' | null
  blockType: 'richTextSection'
}

export const RichTextSectionBlock: React.FC<RichTextSectionBlockProps> = ({
  heading,
  content,
  variant,
}) => {
  return (
    <RichTextSection heading={heading || undefined} variant={variant || undefined}>
      <RichText content={content} enableGutter={false} enableProse={false} />
    </RichTextSection>
  )
}
